// @ts-nocheck




import { createAction, createSlice } from '@reduxjs/toolkit';


import { maintenanceApi } from '../lib/api';

export const CLEAR_MAINTENANCE = 'vehicles/maintenance/clear';
export const SET_MAINTENANCE = 'vehicles/maintenance/set';



const initialState = null;

const clearMaintenanceAction = createAction(CLEAR_MAINTENANCE);
const setMaintenanceAction = createAction(SET_MAINTENANCE);

const maintenanceSlice = createSlice({
  name: 'maintenance',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.
    addCase(setMaintenanceAction, (state, { payload }) => payload).
    addCase(clearMaintenanceAction, () => initialState);
  }
});

export const maintenanceActions = {
  clear: clearMaintenanceAction,
  set: setMaintenanceAction
};

export const clear = () => (dispatch) =>
dispatch(maintenanceActions.clear());

export const setMaintenance = (maintenance) => async (
dispatch) =>
{
  dispatch(maintenanceActions.set({ ...maintenance }));
};

export const addMaintenance = (
maintenance) =>
async (
dispatch,
getState) =>
{
  const addedMaintenance = await maintenanceApi.addMaintenance(maintenance);
  dispatch(maintenanceActions.set(addedMaintenance));
  return addedMaintenance;
};

export const updateMaintenance = (
maintenance) =>
async (
dispatch,
getState) =>
{
  const updatedMaintenance = await maintenanceApi.updateMaintenance(
    maintenance
  );
  dispatch(maintenanceActions.set(updatedMaintenance));
};

export const deleteMaintenance = (id) => async (
dispatch,
getState) =>
await maintenanceApi.deleteMaintenance(id);

export const fetchMaintenance = (id) => async (
dispatch) =>
{
  const maintenance = await maintenanceApi.fetchMaintenance(id);
  dispatch(maintenanceActions.set(maintenance));
};

export default maintenanceSlice.reducer;
